import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { dspReport_template } from "../components/templates/dspReport_template";

declare var ko: any;
declare var page: any;

export class dspReport extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected dspReport_template: dspReport_template;

    protected getModuleName(){

        return "dspReport";
    }

    buildContent() : Array<Element>{

        this.dspReport_template = new dspReport_template( "dspReport", this.viewModel, this );
        this.template = this.dspReport_template;

        return [this.dspReport_template.build()];
    }

    public fillPage() : void{

        this.dspReport_template.buildDatePickerCalendar();
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/dsp_report/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();
            });

            if(req.request.readyState == 4){
                if(req.request.status == 200){

                    obj.loadingOut(obj.dspReport_template.builtTemplate);
                }
            }
        }
    }

    protected updateFilters(responseParsed: any){

        this.dspReport_template.setBrandFilterItems(responseParsed.portfolios);
        this.dspReport_template.setDspFilterItems(responseParsed.dspNames);
        this.dspReport_template.setSspFilterItems(responseParsed.sspNames);
    }

    public getListData(): void{

        this.loadingIn(this.dspReport_template.builtTemplate.children.namedItem("list-results"));

        let subViewModel = this.dspReport_template.getViewModelForRequest();
        let baseApiUrl = '/api/dsp_report/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.dspReport_template.validationsList.clearMessages();
                obj.updateList(responseParsed);
            });

            if(req.request.readyState == 4){
                if(req.request.status == 200){

                    obj.loadingOut(obj.dspReport_template.builtTemplate.children.namedItem("list-results"));
                }
            }
        }
    }

    protected updateList(responseParsed: any){

        this.dspReport_template.setDspHeaders(responseParsed.dspHeaders);
        this.dspReport_template.setDspData(responseParsed.dspData);
    }

    protected filterMultipleSelectorOnChange(){

        this.getListData();
    }

    protected filterDateOnChange(){

        this.getListData();
    }

    public filterDropdownOnChange(){

        this.getListData();
    }
}



// WEBPACK FOOTER //
// ./js/modules/dspReport.ts